export default ({ children }) => children